import { c as _c } from "react/compiler-runtime";
import './chat.scss';
import { cn } from '@module/lib/utils';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import type { EventAnimCoinMessage, LayoutChatMessage } from '@module/types/centrifuge/public-message/eventMessageTypes';
interface Props {
  item: LayoutChatMessage | EventAnimCoinMessage;
}
export default function LayoutChat(t0) {
  const $ = _c(16);
  const {
    item
  } = t0;
  const isDark = useIsDarkModeStore(_temp);
  const {
    message
  } = item.data;
  const messageText = message.message;
  const {
    messageHTML
  } = message;
  const {
    header
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    middle
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    footer
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    fontColor
  } = message.opt.layout[isDark ? "black" : "white"];
  let middleStyle;
  if ($[0] !== fontColor || $[1] !== middle) {
    middleStyle = {};
    if (middle) {
      if (middle.img) {
        middleStyle.background = `url('${middle.img}') repeat-y left top / 100% auto`;
      }
      if (middle.width) {
        middleStyle.width = `${middle.width}px`;
      }
      if (fontColor) {
        middleStyle.color = fontColor;
      }
    }
    $[0] = fontColor;
    $[1] = middle;
    $[2] = middleStyle;
  } else {
    middleStyle = $[2];
  }
  let t1;
  if ($[3] !== header) {
    t1 = header && <img src={header.img} alt="header" className="header" height={header.height} width={header.width} />;
    $[3] = header;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== messageHTML || $[6] !== messageText || $[7] !== middle || $[8] !== middleStyle) {
    t2 = messageHTML ? <div className={cn("middle", {
      default: !middle
    })} dangerouslySetInnerHTML={{
      __html: messageHTML
    }} style={middleStyle} /> : <div className={cn("middle", {
      default: !middle
    })} style={middleStyle}>{messageText}</div>;
    $[5] = messageHTML;
    $[6] = messageText;
    $[7] = middle;
    $[8] = middleStyle;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== footer) {
    t3 = footer && <img src={footer.img} alt="footer" className="footer" height={footer.height} width={footer.width} />;
    $[10] = footer;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className="layout-chat-message">{t1}{t2}{t3}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp(state) {
  return state.isDark;
}